import { render, staticRenderFns } from "./ModalCobranca.vue?vue&type=template&id=998443a6&scoped=true"
import script from "./ModalCobranca.vue?vue&type=script&lang=js"
export * from "./ModalCobranca.vue?vue&type=script&lang=js"
import style0 from "./ModalCobranca.vue?vue&type=style&index=0&id=998443a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998443a6",
  null
  
)

export default component.exports